import {message, ModalProps, Table} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {useForm} from 'form-render';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {useDict} from '../../../dict';
import {ProColumnsType} from 'table-render';
import ProTable from '../../../../../../Components/ProTable';
import {Status} from '../../../../../../Services/common';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../../Utils/common';
import useModalHandler from '../../../../../../Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import {
    changeServiceStatus,
    getCustomerServiceMenu,
    nodeMoveDown,
    nodeMoveUp,
    ServiceMenuProps,
} from '../../../service';
import {LinkButton} from '../../../../../../Features/Buttons/LinkButton';
import {ArrowDownOutlined, ArrowUpOutlined} from '@ant-design/icons';

interface Props extends ModalProps {
    serviceDetailId: string;
    customerId: string;
    onOk: () => void;
}

const Index = ({serviceDetailId, customerId, onOk, ...props}: Props) => {
    const form = useForm();
    const dict = useDict();
    const editModal = useModalHandler({component: EditModal});

    function reload() {
        defaultData?.refetch();
    }

    const defaultData = useQuery({
        queryKey: ['getCustomerServiceMenu', customerId, serviceDetailId],
        queryFn: () =>
            getCustomerServiceMenu({
                serviceDetailId,
                customerId,
            }),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const [changeStatusAction, {loading: changeLoading}] =
        useRequestFn(changeServiceStatus);

    async function changeStatus(id: string, status: Status) {
        try {
            await changeStatusAction(id, status);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function onEditOk() {
        editModal.close();
        reload();
    }

    const moveDown = useMutation({
        mutationFn: nodeMoveDown,
        onSuccess: () => {
            defaultData.refetch();
        },
    });
    const moveUp = useMutation({
        mutationFn: nodeMoveUp,
        onSuccess: () => {
            defaultData.refetch();
        },
    });

    const columns: ProColumnsType<ServiceMenuProps> = [
        {title: '名称', dataIndex: 'name', width: 150},
        {
            title: '菜单级别',
            dataIndex: 'levelType',
            render: dict.MenuType.getName,
            width: 120,
        },
        {title: '编码', dataIndex: 'code', width: 180},
        {
            title: '状态',
            dataIndex: 'status',
            render: dict.Status.getName,
            width: 60,
        },
        {
            title: '操作',
            dataIndex: 'id',
            align: 'center',
            width: 150,
            render: (id: string, item, index) => (
                <ProTable.Operate>
                    <div className={Style.fix}>
                        <LinkButton onClick={() => moveUp.mutate(id)}>
                            <ArrowUpOutlined />
                        </LinkButton>
                        <LinkButton onClick={() => moveDown.mutate(id)}>
                            <ArrowDownOutlined />
                        </LinkButton>
                    </div>
                    <LinkButton
                        onClick={() =>
                            editModal.open({
                                customerId,
                                serviceDetailId,
                                defaultData: item,
                                onOk: onEditOk,
                            })
                        }>
                        编辑
                    </LinkButton>
                    <LinkButton
                        onClick={() =>
                            changeStatus(
                                id,
                                item.status === Status.Freeze
                                    ? Status.Normal
                                    : Status.Freeze,
                            )
                        }>
                        {item.status === Status.Freeze ? '启用' : '停用'}
                    </LinkButton>
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <ProModal
            {...props}
            footer={null}
            width={1200}
            title="应用服务菜单管理"
            onOk={form.submit}>
            <div className={Style.root}>
                {defaultData?.data && (
                    <Table
                        rowKey="id"
                        loading={changeLoading || defaultData?.isFetching}
                        columns={columns}
                        dataSource={defaultData?.data}
                        expandable={{
                            defaultExpandAllRows: true,
                        }}
                    />
                )}

                {editModal.render()}
            </div>
        </ProModal>
    );
};

export default Index;
